<template>
    <div class="ml-5 mr-5"  >
 
       <b-loading  :active.sync="isFullScreenSearching" ></b-loading>
       <!-- {{dataCBCSpecLN }} -->
       <!-- {{dataCBCSpecLN['info']}} -->
            <b-field grouped v-if="dataCBCSpecLN && IDLABSelected.idlab" class="mb-5">
               
            <b-field label="Request"  v-if="dataCBCSpecLN['info'] " >
                <b-tag  style="background-color: paleturquoise; color: blue" size="is-medium"> {{ dataCBCSpecLN['info'].date_req }}&nbsp;
                    <span class="is-size-7" style="color: darkslateblue" >{{  dataCBCSpecLN['info'].time_req }}</span>&nbsp;
                    <b-tag rounded>   {{ dataCBCSpecLN['info'].req_by  }}  </b-tag>
                </b-tag>
            </b-field>

            <b-field label="Cancel" v-if="dataCBCSpecLN['info'].date_cancel">
                <b-tag  style="background-color: crimson; color: white" size="is-medium">{{ dataCBCSpecLN['info'].date_cancel }}&nbsp;
                    <span class="is-size-7" style="color: white" >{{ dataCBCSpecLN['info'].time_cancel }}</span>&nbsp;
                    <b-tag rounded>   {{ dataCBCSpecLN['info'].cancel_by }}  </b-tag>
                </b-tag>
            </b-field>

            <b-field label="Reject" v-if="dataCBCSpecLN['info'].date_reject">
                <b-tag  style="background-color: crimson; color: white" size="is-medium">{{  dataCBCSpecLN['info'].date_reject }}&nbsp;
                    <span class="is-size-7" style="color: white" >{{   dataCBCSpecLN['info'].time_reject }}</span>&nbsp;
                    <b-tag rounded>   {{  dataCBCSpecLN['info'].reject_by }}  </b-tag>
                </b-tag>
            </b-field>

            <b-field label="Result" v-if="dataCBCSpecLN['info'].date_resulted"  >
                <b-tag  style="background-color: paleturquoise; color: blue" size="is-medium">{{  dataCBCSpecLN['info'].date_resulted }}&nbsp;
                    <span class="is-size-7" style="color: darkslateblue" >{{  dataCBCSpecLN['info'].time_resulted }}</span>&nbsp;
                    <b-tag rounded>   {{ dataCBCSpecLN['info'].resulted_by }}  </b-tag>
                </b-tag>
            </b-field>


            <b-field label="Last Update" v-if="dataCBCSpecLN['info'].date_resulted_n"  >
                <b-tag  style="background-color: paleturquoise; color: blue" size="is-medium">{{ dataCBCSpecLN['info'].date_resulted_n }}&nbsp;
                    <span class="is-size-7" style="color: darkslateblue" >{{  dataCBCSpecLN['info'].time_resulted_n_time }}</span>&nbsp;
                    <b-tag rounded>   {{ dataCBCSpecLN['info'].resulted_n_by }}  </b-tag>
                </b-tag>
            </b-field>


            <b-field label="Hold Status" v-if="dataCBCSpecLN['info'].hold"  >
                <b-tag  size="is-medium" type="is-warning is-light">
                    <span class="has-text-info-dark">
                       <b-icon
                               icon="car-brake-hold"
                               size="is-medium">
                    </b-icon>
                    </span>
                </b-tag>
            </b-field>
 
            <!-- <b-field label="#"    >
           

                  <b-dropdown aria-role="list">
                    <template #trigger="{ active }">
                        <b-button
                            label=""
                            type="is-light"
                            size="is-small"
                            :icon-right="active ? 'menu-up' : 'menu-down'" />
                    </template>


                    <b-dropdown-item aria-role="listitem" 
                          :disabled=" !dataCBCSpecLN['info'].status || !userRoleFind(10)" 
                          @click="ManuallyCreateLabAutomateShow">Edit
                    </b-dropdown-item>
                    <b-dropdown-item aria-role="listitem" 
                         :disabled ="!userRoleFind(10)"
                         @click="changeStatusCBCLab">{{ dataCBCSpecLN['info'].status ? 'Disable' : 'Enable'}}
                    </b-dropdown-item>
                    <b-dropdown-item aria-role="listitem" 
                          :disabled=" !dataCBCSpecLN['info'].status || !userRoleFind(6) " 
                          @click="printLabCBC">Print
                    </b-dropdown-item>   

                  
                </b-dropdown>
            </b-field> -->

   
            <b-field label="#"    >
                    <template #label>
                     <span class="has-text-white"> # </span> 
                    </template>
                <b-button  size="is-small" 
                           type="is-primary" 
                           :disabled=" !dataCBCSpecLN['info'].status || !userRoleFind(11)"  
                            @click="ManuallyCreateLabAutomateShow"
                           >Edit</b-button>
            </b-field>
            <b-field label="#"    >
                    <template #label>
                     <span class="has-text-white"> # </span> 
                    </template>
                <b-button  size="is-small" 
                           type="is-primary" 
                           :disabled ="!userRoleFind(10)" 
                            @click="changeStatusCBCLab"
                           >{{ dataCBCSpecLN['info'].status ? 'Disable' : 'Enable'}}</b-button>
            </b-field>
            <b-field label="#"    >
                    <template #label>
                     <span class="has-text-white"> # </span> 
                    </template> 
                <b-button  size="is-small" 
                           type="is-primary" 
                           :disabled=" !dataCBCSpecLN['info'].status || !userRoleFind(12) " 
                           @click="printLabCBC"
                           >Print</b-button>
            </b-field>




            </b-field>

       

      <!-- <div v-if=" dataCBCSpecLN ">
        
           <ol v-for="DATA in dataCBCSpecLN['hm']" :key="DATA.field_name">
             <li>{{DATA.field_name}}</li>
           </ol>
      </div> -->
         <b-notification
            v-if="dataCBCSpecLN && dataCBCSpecLN.info && !dataCBCSpecLN.info.status"
            type="is-danger"
            :closable="false"
            has-icon
            aria-close-label="Close notification"
            role="alert"
             style="font-size: 40px; "
            >
            ยกเลิก (Disabled Status)
        </b-notification>


         <!-- v-if="dataCBCSpecLN && dataCBCSpecLN.info && dataCBCSpecLN.info.status" -->
    <div   v-if="dataCBCSpecLN && dataCBCSpecLN.info && dataCBCSpecLN.info.status"  >
       
                <table class="table is-bordered is-striped  " width="100%" >
       
       
                    <template v-if="dataCBCSpecLN  && dataCBCSpecLN['hm'].length>0">
                        <thead>
                            <tr > 
                                <th colspan="7" class="is-size-3  has-text-grey-dark" style="border : none;">Hematology</th>
                            </tr>

                            <tr class="is-size-6 has-text-grey-dark ">
                            <th :width="col1_Width">Abbreviations</th>
                            <th :width="col2_Width">Parameter</th>
                            <th :width="col3_Width">Value</th>
                            <th :width="col4_Width">Unit</th>
                            <th :width="col5_Width">Reference</th>
                            <th :width="col6_Width">Flag</th>
                            <th :width="col7_Width">Machine ID</th>
                            </tr>
                        </thead>
                        <tbody>
                                <tr  class="is-size-6 has-text-grey-dark "  v-for="DATA in dataCBCSpecLN['hm']" :key="DATA.field_name">
                                <td   :class="getClassDependFlag(DATA.flag)" > {{getNameFullnameFromFieldKey_CBC(DATA.field_name).nick_name}} </td>
                                <td   :class="getClassDependFlag(DATA.flag)" >  {{getNameFullnameFromFieldKey_CBC(DATA.field_name).full_name}} </td>
                                <td   :class="getClassDependFlag(DATA.flag)" > {{DATA.val}} </td>
                                <td   :class="getClassDependFlag(DATA.flag)" > {{DATA.unit}} </td>
                                <td   :class="getClassDependFlag(DATA.flag)" > {{DATA.ref}} </td>
                                <td   :class="getClassDependFlag(DATA.flag)"> {{DATA.flag}} </td>
                                <td   :class="getClassDependFlag(DATA.flag)"> {{DATA.machine_id}} </td>
                                </tr>
                        </tbody>
                    </template>

            
                    <template v-if="dataCBCSpecLN  && dataCBCSpecLN['blmor'].length>0">
                    
                        <thead>
                            <tr> 
                                <th colspan="7" class="is-size-3 has-text-grey-dark" style="border : none;">Blood Morphology </th>
                            </tr>

                            <tr class="is-size-6 has-text-grey-dark ">
                            <th  colspan="6">Blood Morphology</th>
                            <th   >Machine ID</th>
                            </tr>

                        </thead>
                        <tbody>
                                <tr  class="is-size-6 has-text-grey-dark "   v-for="data_blmor in  dataCBCSpecLN['blmor']" :key="data_blmor.id">
                                <td   colspan="6" > 
                                    {{ data_blmor.blood_mor_name}} 
                                </td>
                                <td    > 
                                    {{ data_blmor.machine_id}} 
                                </td>
                                <!-- <td   colspan="7" > 
                                        <b-taglist  >
                                            <b-tag type="is-info is-light"  size="is-large" v-for="data_blmor in  dataCBCSpecLN['blmor']" :key="data_blmor.id">{{data_blmor.blood_mor_name}}</b-tag> 
                                        </b-taglist>
                                </td> -->
                                </tr>
                        </tbody>
                    </template>



                    <template v-if="dataCBCSpecLN && dataCBCSpecLN['chemistry'].length>0">
                        <thead>
                            <tr> 
                                <th colspan="7" class="is-size-3 has-text-grey-dark" style="border : none;">Chemistry</th>
                            </tr>
                            <tr class="is-size-6 has-text-grey-dark ">
                            <th>Abbreviations</th>
                            <th>Param Name</th>
                            <th>Value</th>
                            <th>Unit</th>
                            <th>Reference</th>
                            <th>Flag</th>
                            <th>Machine ID</th>
                            </tr>
                        </thead>
                        <tbody>
                                <tr  class="is-size-6 has-text-grey-dark "  v-for="DATA in dataCBCSpecLN['chemistry']" :key="DATA.field_name">
                                <td  :class="getClassDependFlag(DATA.flag)"> {{getNameFullnameFromFieldKey_CBC(DATA.field_name).nick_name}} </td>
                                <td  :class="getClassDependFlag(DATA.flag)"> {{getNameFullnameFromFieldKey_CBC(DATA.field_name).full_name}} </td>
                                <td  :class="getClassDependFlag(DATA.flag)"> {{DATA.val}} </td>
                                <td  :class="getClassDependFlag(DATA.flag)"> {{DATA.unit}} </td>
                                <td  :class="getClassDependFlag(DATA.flag)"> {{DATA.ref}} </td>
                                <td  :class="getClassDependFlag(DATA.flag)"> {{DATA.flag}} </td>
                                <td  :class="getClassDependFlag(DATA.flag)"> {{DATA.machine_id}} </td>
                                </tr>
                        </tbody>
                    </template>
                    
                    
                    <template v-if="dataCBCSpecLN  && dataCBCSpecLN['blparasite_v1'].length>0">
                        <thead>
                            <tr> 
                                <th colspan="7" class="is-size-3 has-text-grey-dark" style="border : none;">Blood Parasite V1</th>
                            </tr>
                            <tr class="is-size-6 has-text-grey-dark ">
                            
                            <th>Parameter</th>
                            <th>Value</th>
                            <th colspan="5"></th>
                            <!-- <th></th>
                            <th></th>
                            <th></th> -->
                            </tr>
                        </thead>
                        <tbody>
                                <tr  class="is-size-6 has-text-grey-dark "  v-for="DATA in dataCBCSpecLN['blparasite_v1']" :key="DATA.id">
                                
                                <td   > {{ DATA.name}} </td>
                                <td   > {{ DATA.val}}  </td>
                                <td    colspan="5">  </td>
                                <!-- <td   >  </td>
                                <td   >  </td>
                                <td   >  </td> -->
                                </tr>
                        </tbody>
                    </template>


                    <template v-if="dataCBCSpecLN  && dataCBCSpecLN['blparasite_v2'].length>0">
                        <thead>
                            <tr> 
                                <th colspan="7" class="is-size-3 has-text-grey-dark" style="border : none;">Blood Parasite V2</th>
                            </tr>
                            <tr class="is-size-6 has-text-grey-dark ">
                        
                            <th>Parameter</th>
                            <th>Value</th>
                            <th colspan="5"></th>
                        
                            </tr>
                        </thead>
                        <tbody>
                                <tr  class="is-size-6 has-text-grey-dark "  v-for="DATA in dataCBCSpecLN['blparasite_v2']" :key="DATA.id">
                            
                                <td   > {{ DATA.bl_parasite_name}} </td>
                                <td   > {{ DATA.bl_parasite_val}}  </td>
                                <td  colspan="5" >  </td>
                            
                                </tr>
                        </tbody>
                    </template>




                    <template v-if="dataCBCSpecLN  && dataCBCSpecLN['blparasite_v3']!=null">
                        <thead>
                            <tr> 
                                <th colspan="7" class="is-size-3 has-text-grey-dark" style="border : none;">Blood Parasite V3</th>
                            </tr>
                            
                        </thead>
                        <tbody>
                            <tr> 
                                <td colspan="7" class="is-size-3 has-text-grey-dark">
                                  {{dataCBCSpecLN['blparasite_v3']['res_status']}}
                                </td>
                            
                            </tr>
                            <template v-if="dataCBCSpecLN['blparasite_v3']['detail'].length>0">
                                <tr class="is-size-6 has-text-dark has-text-weight-bold" >
                                    <td   > Param Name</td>
                                    <td   > Amount </td>
                                    <td   > Unit </td>
                                    <td  colspan="3" > Remark </td>
                                    <td   > Machine ID </td>
                                </tr>


                                <tr  class="is-size-6 has-text-grey-dark "  v-for="DATA in dataCBCSpecLN['blparasite_v3']['detail']" :key="DATA.id">
                                    <td   > {{ DATA.bl_parasite_name}} </td>
                                    <td   > {{ DATA.amount}}  </td>
                                    <td   > {{ DATA.unit}}  </td>
                                    <td    colspan="3"  > {{ DATA.remark}}  </td>
                                    <td   > {{ DATA.machine_id}}  </td>
                                </tr>
                            </template>    
                        </tbody>
                    </template>







                    <template v-if="dataCBCSpecLN  && dataCBCSpecLN['ua_v1'].length>0">
                        <template v-if="!onlyBugUAInPrevVersion(dataCBCSpecLN['ua_v1'])">
                        <thead>
                            <tr> 
                                <th colspan="7" class="is-size-3 has-text-grey-dark" style="border : none;">UA V1</th>
                            </tr>
                            <tr class="is-size-6 has-text-grey-dark ">
                            <th>Parameter</th>
                            <th>Value</th>
                            <th colspan="5">Remark</th>
                            </tr>
                        </thead>
                        <tbody>
                                <tr  class="is-size-6 has-text-grey-dark "  v-for="DATA in dataCBCSpecLN['ua_v1']" :key="DATA.id">
                                <td   > {{ DATA.name}} </td>
                                <td   >
                                    <span v-if="DATA.type==0 ||DATA.type==1 ">
                                        {{ DATA.val}} <span v-if="DATA.val_pos">({{DATA.val_pos}})</span>     
                                    </span>

                                    <span v-if="DATA.type==2 ">
                                        {{ DATA.val}}
                                    </span>  
                                    
                                </td>
                            
                                <td  v-if="DATA.type==2 " colspan="5"> {{ DATA.val_pos_str}}  </td>
                                <td  v-else colspan="5"  >  </td>



                                </tr>
                        </tbody>




                        </template>
                    </template>

 
                    <template v-if="dataCBCSpecLN  && dataCBCSpecLN['ua_v2'].length>0">
                        <!-- {{ dataCBCSpecLN['ua_v2']}} -->
                        <template v-if="!onlyBugUAInPrevVersion(dataCBCSpecLN['ua_v2'])">
                        <thead>
                            <tr> 
                                <th colspan="7" class="is-size-3 has-text-grey-dark" style="border : none;">UA V2</th>
                            </tr>
                            <tr class="is-size-6 has-text-grey-dark ">
                            <th>Parameter</th>
                            <th>Value</th>
                            <th></th>
                            
                            <th colspan="5"></th>
                            </tr>
                        </thead>
                        <tbody>
                            <!-- type 0 == collect_tech,color,trans , 1 ==  spgr,ph,cretinine , 2 == rbc,wbc , 3 == nirite...urobilinogen , 4 == cast,cystal, epith-->
                                <tr  class="is-size-6 has-text-grey-dark "  v-for="DATA in dataCBCSpecLN['ua_v2']" :key="DATA.id">
                                <td   > {{ DATA.name}} </td>
                                <td   >
                                    <span v-if="DATA.type==0 ">
                                        {{ DATA.val}}  
                                        <!-- <span v-if="DATA.remark">({{DATA.remark}})</span>  -->
                                    </span>

                                    <span v-if="DATA.type==1 || DATA.type==2">
                                        {{ DATA.val_str}}
                                    </span>


                                    <span v-if="DATA.type==3 ">
                                        {{ DATA.val_str}} <span v-if="DATA.val_pos_str">({{DATA.val_pos_str}})</span>  
                                    </span>  


                                    <span v-if="DATA.type==4 ">
                                        {{ DATA.val_str}} 
                                    </span>  
                                    
                                </td>

                                <td>
                                    <span v-if="DATA.remark">{{DATA.remark}}</span>
                                    <template v-if="DATA.type==4 ">
                                        <div>
                                            {{ DATA.val_pos_str}} 
                                        </div>
                                    </template>
                                </td>    
                            
                                <!-- <td  v-if="DATA.type==4 " colspan="5"> {{ DATA.val_pos_str}}  </td> -->
                                <!-- <td  v-else colspan="5"  >  </td> -->
                                <td  colspan="5"  >  </td>



                                </tr>

                        </tbody>
                        </template>     
                    </template>     


                    <template v-if="dataCBCSpecLN  && dataCBCSpecLN['bf'].length>0">
                        <thead>
                            <tr> 
                                <th colspan="7" class="is-size-3 has-text-grey-dark" style="border : none;">Body fluid</th>
                            </tr>
                            <tr class="is-size-6 has-text-grey-dark ">
                            <th>Abbreviations</th>
                            <th>Parameter</th>
                            <th>Value</th>
                            <th>Unit</th>
                            <th>Reference</th>
                            <th>Flag</th>
                            <th>Machine ID</th>
                            </tr>
                        </thead>
                        <tbody>
                                <tr  class="is-size-6 has-text-grey-dark "  v-for="DATA in dataCBCSpecLN['bf']" :key="DATA.field_name">
                                <td   :class="getClassDependFlag(DATA.flag)"> {{getNameFullnameFromFieldKey_CBC(DATA.field_name).nick_name}} </td>
                                <td   :class="getClassDependFlag(DATA.flag)"> {{getNameFullnameFromFieldKey_CBC(DATA.field_name).full_name}} </td>
                                <td   :class="getClassDependFlag(DATA.flag)" > {{DATA.val}} </td>
                                <td   :class="getClassDependFlag(DATA.flag)"> {{DATA.unit}} </td>
                                <td   :class="getClassDependFlag(DATA.flag)"> {{DATA.ref}} </td>
                                <td   :class="getClassDependFlag(DATA.flag)"> {{DATA.flag}} </td>
                                <td   :class="getClassDependFlag(DATA.flag)"> {{DATA.machine_id}} </td>
                                </tr>
                        </tbody>
                    </template>


                    
                    <template v-if="dataCBCSpecLN && dataCBCSpecLN['hormone_v1'].length>0">
                        <thead>
                            <tr> 
                                <th colspan="7" class="is-size-3 has-text-grey-dark" style="border : none;">Hormones V1</th>
                            </tr>
                            <tr class="is-size-6 has-text-grey-dark ">
                            <th>Abbreviations</th>
                            <th>Parameter</th>
                            <th>Value</th>
                            <th>Unit</th>
                            <th>Reference</th>
                            <th>Flag</th>
                            <th>Machine ID</th>
                            </tr>
                        </thead>
                        <tbody>
                                <tr  class="is-size-6 has-text-grey-dark "  v-for="DATA in dataCBCSpecLN['hormone_v1']" :key="DATA.id">
                                <td>  </td>
                                <td> {{DATA.name}} </td>
                                <td> {{DATA.val }}</td>
                                <td>  </td>
                                <td>  </td>
                                <td>  </td>
                                <td>  </td>
                                </tr>
                        </tbody>
                    </template>





                    <template v-if="dataCBCSpecLN && dataCBCSpecLN['hormone'].length>0">
                        <thead>
                            <tr> 
                                <th colspan="7" class="is-size-3 has-text-grey-dark" style="border : none;">Hormones</th>
                            </tr>
                            <tr class="is-size-6 has-text-grey-dark ">
                            <th>Abbreviations</th>
                            <th>Parameter</th>
                            <th>Value</th>
                            <th>Unit</th>
                            <th>Reference</th>
                            <th>Flag</th>
                            <th>Machine ID</th>
                            </tr>
                        </thead>
                        <tbody>
                                <tr  class="is-size-6 has-text-grey-dark "  v-for="DATA in dataCBCSpecLN['hormone']" :key="DATA.field_name">
                                <td> {{getNameFullnameFromFieldKey_CBC(DATA.field_name).nick_name}} </td>
                                <td> {{getNameFullnameFromFieldKey_CBC(DATA.field_name).full_name}} </td>
                                <td> {{DATA.val}} </td>
                                <td> {{DATA.unit}} </td>
                                <td> {{DATA.ref}} </td>
                                <td> {{DATA.flag}} </td>
                                <td> {{DATA.machine_id}} </td>
                                </tr>
                        </tbody>
                    </template>



                    <template v-if="dataCBCSpecLN && dataCBCSpecLN['blood_gas'].length>0">
                        <thead>
                            <tr> 
                                <th colspan="7" class="is-size-3 has-text-grey-dark" style="border : none;">Blood gas</th>
                            </tr>
                            <tr class="is-size-6 has-text-grey-dark ">
                            <th>Abbreviations</th>
                            <th>Parameter</th>
                            <th>Value</th>
                            <th>Unit</th>
                            <th>Reference</th>
                            <th>Flag</th>
                            <th>Machine ID</th>
                            </tr>
                        </thead>
                        <tbody>
                                <tr  class="is-size-6 has-text-grey-dark "  v-for="DATA in dataCBCSpecLN['blood_gas']" :key="DATA.field_name">
                                <td  :class="getClassDependFlag(DATA.flag)"> {{getNameFullnameFromFieldKey_CBC(DATA.field_name).nick_name}} </td>
                                <td  :class="getClassDependFlag(DATA.flag)"> {{getNameFullnameFromFieldKey_CBC(DATA.field_name).full_name}} </td>
                                <td  :class="getClassDependFlag(DATA.flag)"> {{DATA.val}} </td>
                                <td  :class="getClassDependFlag(DATA.flag)"> {{DATA.unit}} </td>
                                <td  :class="getClassDependFlag(DATA.flag)"> {{DATA.ref}} </td>
                                <td  :class="getClassDependFlag(DATA.flag)"> {{DATA.flag}} </td>
                                <td  :class="getClassDependFlag(DATA.flag)"> {{DATA.machine_id}} </td>
                                </tr>
                        </tbody>
                    </template>





                    <template v-if="dataCBCSpecLN && dataCBCSpecLN['outlab'].length>0">
                        <thead>
                            <tr> 
                                <th colspan="7" class="is-size-3 has-text-grey-dark" style="border : none;">Out lab</th>
                            </tr>
                            <tr class="is-size-6 has-text-grey-dark ">
                            <th>Abbreviations</th>
                            <th>Parameter</th>
                            <th>Value</th>
                            <th>Unit</th>
                            <th>Reference</th>
                            <th>Flag</th>
                            <th>Machine ID</th>
                            </tr>
                        </thead>
                        <tbody>
                                <tr  class="is-size-6 has-text-grey-dark "  v-for="DATA in dataCBCSpecLN['outlab']" :key="DATA.field_name">
                                <td  :class="getClassDependFlag(DATA.flag)"> {{getNameFullnameFromFieldKey_CBC(DATA.field_name).nick_name}} </td>
                                <td  :class="getClassDependFlag(DATA.flag)"> {{getNameFullnameFromFieldKey_CBC(DATA.field_name).full_name}} </td>
                                <td  :class="getClassDependFlag(DATA.flag)"> {{DATA.val}} </td>
                                <td  :class="getClassDependFlag(DATA.flag)"> {{DATA.unit}} </td>
                                <td  :class="getClassDependFlag(DATA.flag)"> {{DATA.ref}} </td>
                                <td  :class="getClassDependFlag(DATA.flag)"> {{DATA.flag}} </td>
                                <td  :class="getClassDependFlag(DATA.flag)"> {{DATA.machine_id}} </td>
                                </tr>
                        </tbody>
                    </template>

                   
            
                        

                </table> 


                <section  v-if="dataCBCSpecLN && dataCBCSpecLN['images'].length>0">
                      
                    <p  class="is-size-2 has-text-grey-dark ml-5 subtitle has-text-weight-semibold"> Images</p>
                                 
                    <div class="columns is-multiline">
                                 
                                    <div class="column is-one-quarter-desktop is-half-tablet"   v-for="img in dataCBCSpecLN['images']" :key="img.id" >
                                    
 
                                            <div class="card-image" @click="imageModal(img.path)">
                                                <figure class="image is-4by3"  >
                                                     <img :src="getURLImgWithUUID( img.path )"  >
                                                </figure>


                                                
                                            
                                            </div>
                                            <footer class="card-footer">
                                                <!-- <a class="card-footer-item" @click="imageModal(getURLImgWithUUID( img.path_img ))">
                                                    <b-icon
                                                            icon="magnify"
                                                            size="is-medium">
                                                    </b-icon>
                                                </a>

                                                <a class="card-footer-item" @click="disableImage(img.id)" v-if="modeLabNewsElement==1">
                                                    <b-icon
                                                            icon="delete"
                                                            size="is-medium"
                                                            type="is-danger"
                                                            >
                                                    </b-icon>
                                                </a> -->


                                            </footer>
                                        




                                    </div>

                                  
                    </div>   







                            
                     
                

                </section>
            
                <section  v-if="dataCBCSpecLN &&  dataCBCSpecLN['info'].comment_note != null && dataCBCSpecLN['info'].comment_note.length>0   " class="mb-5">
                    <h2 class="is-size-3 has-text-grey-dark" >Comment</h2>
                    <!-- <pre>{{getDecodeFromBase64ToHtml(dataCBCSpecLN['info'].comment_note)}}</pre> -->
                    <pre>{{dataCBCSpecLN['info'].comment_note}}</pre>
                </section> 


                <section  v-if="dataCBCSpecLN && dataCBCSpecLN['info'].singni_phy != null   && dataCBCSpecLN['info'].singni_phy.length>0  " class="mb-5">
                    <h2 class="is-size-3 has-text-grey-dark" >singni_phy</h2>
                    <pre>{{dataCBCSpecLN['info'].singni_phy}}</pre>
                </section> 


                <section  v-if="dataCBCSpecLN && dataCBCSpecLN['info'].tentative_dx != null && dataCBCSpecLN['info'].tentative_dx.length>0  " class="mb-5">
                    <h2 class="is-size-3 has-text-grey-dark" >Tentative Dx</h2>
                    <!-- <pre>{{getDecodeFromBase64ToHtml( dataCBCSpecLN['info'].tentative_dx) }}</pre> -->
                    <pre>{{  dataCBCSpecLN['info'].tentative_dx }}</pre> 
                </section> 


                <section  v-if="dataCBCSpecLN && dataCBCSpecLN['info'].test_desire != null && dataCBCSpecLN['info'].test_desire.length>0  " class="mb-5">
                    <h2 class="is-size-3 has-text-grey-dark" >Test Desire</h2>
                    <pre>{{dataCBCSpecLN['info'].test_desire}}</pre>
                </section> 


                <section  v-if="dataCBCSpecLN && dataCBCSpecLN['info'].special_rq != null && dataCBCSpecLN['info'].special_rq.length>0   " class="mb-5">
                    <h2 class="is-size-3 has-text-grey-dark" >Special Request</h2>
                    <pre>{{dataCBCSpecLN['info'].special_rq}}</pre>
                </section> 
                
                <section  v-if="dataCBCSpecLN && dataCBCSpecLN['info'].diagnosis_note != null && dataCBCSpecLN['info'].diagnosis_note.length>0   " class="mb-5">
                    <h2 class="is-size-3 has-text-grey-dark" >Diagnosis Note</h2>
                    <pre>{{ getDecodeFromBase64ToHtml(dataCBCSpecLN['info'].diagnosis_note)}}</pre>
                     <!-- <pre>{{  dataCBCSpecLN['info'].diagnosis_note }}</pre>  -->
                </section>  

                <section  v-if="dataCBCSpecLN && dataCBCSpecLN['info'].result_remark != null && dataCBCSpecLN['info'].result_remark.length>0   " class="mb-5">
                    <h2 class="is-size-3 has-text-grey-dark" >Result Remark</h2>
                    <pre>{{ getDecodeFromBase64ToHtml( dataCBCSpecLN['info'].result_remark) }}</pre>
                     <!-- <pre>{{   dataCBCSpecLN['info'].result_remark }}</pre> -->
                </section>  
                
    </div>

    
    

   
<!-- 
     <h1>CBC_DetailEachID_V2</h1>  
     <br> 
     {{IDLABSelected}}
     <br>
     {{dataCBCSpecLN}} -->


          
   <!-- {{dataCBCSpecLN.info.diagnosis_note  }} -->
   <!-- :mode = "1"
                    :dataToEdit="dataCBCSpecLN" -->
         <b-modal
                v-if="isManuallyCreateLabAutomateShowing"
                v-model="isManuallyCreateLabAutomateShowing"
                has-modal-card
                full-screen
        >

            <ManuallyCreateLabAutomateV2
                    v-if="isManuallyCreateLabAutomateShowing"
                    :isComponentModalActive ="isManuallyCreateLabAutomateShowing"
                    @close = "closeManuallyCreateLabAutomateShow"
                    @closeWithChangeData = "closeManuallyCreateLabAutomate_WithChangeData"
            />
        </b-modal>



        <b-modal :active.sync="isImageModalActive">
                <p class="image ">
                    <img :src=dataUrl>
                </p>
        </b-modal>




    </div>
</template>


<script>
import { mapState , mapMutations, mapActions } from "vuex";
// import ManuallyCreateLabAutomate from '../LABAutomate/ManuallyCreateLabAutomate/ManuallyCreateLabAutomate.vue' 
import ManuallyCreateLabAutomateV2 from  '../LABAutomate/ManuallyCreateLabAutomate/ManuallyCreateLabAutomateV2.vue' 
import getNameFullnameFromFieldKey_CBC from '../../mixins/methods/getNameFullnameFromFieldKey_CBC'
import getDecodeFromBase64ToHtml from "../../mixins/methods/getDecodeFromBase64ToHtml";
import userRoleFind from '../../mixins/methods/userRoleFind'

import axios from "axios";
import {getBaseURLforBackEnd, getConfigAxios, genUUID, CALL_FROM} from '@/utils.js'
import {  getBaseURLLabCBCImages}  from '@/utils.js' 

 
 

export default {
    name : "CBC_DetailEachID_V2",
    // mounted(){
    //     console.log("mount CBC_DetailEachID_V2")
    // },
    components:{
        ManuallyCreateLabAutomateV2,
   
    },
    mixins:[getNameFullnameFromFieldKey_CBC,getDecodeFromBase64ToHtml,userRoleFind,],
    props:{
          dataCBCSpecLN : Object,
          IDLABSelected : Object,
    },
    computed:{
            ...mapState({
                access_token : state => state.master_data.access_token,
                mapGroupName_From_Key : state => state.manually_create_lab_automate.mapGroupName_From_Key ,
                mapField_Fullname : state => state.manually_create_lab_automate.mapField_Fullname ,
                lab_HIS_LIS_Mapping: state => state.manually_create_lab_automate.lab_HIS_LIS_Mapping ,


                blMor: state => state.manually_create_lab_automate.blMor ,
                blMorSelected: state => state.manually_create_lab_automate.blMorSelected ,


                modeManuallyLabAutomate: state => state.manually_create_lab_automate.modeManuallyLabAutomate ,  // 0 == new insert , 1 == edit mode
                dataToEdit_ManuallyLabAutomate: state => state.manually_create_lab_automate.dataToEdit_ManuallyLabAutomate , 



                listoflabopdtarget_v2 : state => state.listoflab_opdtarget.listoflabopdtarget_v2,
                CBCWorkList: state => state.worklist.CBCWorkList,
            
                user_role: state => state.master_data.user_role ,
                user_full_name_surname : state => state.master_data.user_full_name_surname,


                hasEditImagesHappenWhenEdit: state => state.manually_create_lab_automate.hasEditImagesHappenWhenEdit , 


            }),

            modeManuallyLabAutomate_Model :{
                get: function(){
                   return this.modeManuallyLabAutomate
                },
                set: function(newValue){
                   this.setModeManuallyLabAutomate(newValue)
                }
            },


            dataToEdit_ManuallyLabAutomate_Model :{
                get: function(){
                   return this.dataToEdit_ManuallyLabAutomate
                },
                set: function(newValue){
                   this.setDataToEdit_ManuallyLabAutomate(newValue)
                }
            },



     }, 
    methods:{
        ...mapActions({
            fetchBlMor : 'manually_create_lab_automate/fetchBlMor' ,
        }),
        ...mapMutations({
            setCommentNote : 'manually_create_lab_automate/setCommentNote' ,
            setSingni_phy : 'manually_create_lab_automate/setSingni_phy' ,
            setTentative_dx: 'manually_create_lab_automate/setTentative_dx' ,
            setTest_desire: 'manually_create_lab_automate/setTest_desire' ,
            setSpecial_rq: 'manually_create_lab_automate/setSpecial_rq' ,




            setOpdSelected : 'manually_create_lab_automate/setOpdSelected' ,
            setModeManuallyLabAutomate: 'manually_create_lab_automate/setModeManuallyLabAutomate' ,
            setDataToEdit_ManuallyLabAutomate: 'manually_create_lab_automate/setDataToEdit_ManuallyLabAutomate' ,

            setHasEditImagesHappenWhenEdit: 'manually_create_lab_automate/setHasEditImagesHappenWhenEdit' ,
        }),




        printLabCBC(){

                this.isFullScreenSearching = true
                
                

                this.dataCBCSpecLN.hm.forEach(dat=>{
                    dat['abb'] = this.getNameFullnameFromFieldKey_CBC(dat.field_name).nick_name
                    dat['parameter'] = this.getNameFullnameFromFieldKey_CBC(dat.field_name).full_name
                })

                this.dataCBCSpecLN.bf.forEach(dat=>{
                    dat['abb'] = this.getNameFullnameFromFieldKey_CBC(dat.field_name).nick_name
                    dat['parameter'] = this.getNameFullnameFromFieldKey_CBC(dat.field_name).full_name
                })

                this.dataCBCSpecLN.chemistry.forEach(dat=>{
                    dat['abb'] = this.getNameFullnameFromFieldKey_CBC(dat.field_name).nick_name
                    dat['parameter'] = this.getNameFullnameFromFieldKey_CBC(dat.field_name).full_name
                })

                this.dataCBCSpecLN.hormone_v1.forEach(dat=>{
                    dat['abb'] = this.getNameFullnameFromFieldKey_CBC(dat.field_name).nick_name
                    dat['parameter'] = this.getNameFullnameFromFieldKey_CBC(dat.field_name).full_name
                })

                this.dataCBCSpecLN.hormone.forEach(dat=>{
                    dat['abb'] = this.getNameFullnameFromFieldKey_CBC(dat.field_name).nick_name
                    dat['parameter'] = this.getNameFullnameFromFieldKey_CBC(dat.field_name).full_name
                })

                this.dataCBCSpecLN.blood_gas.forEach(dat=>{
                    dat['abb'] = this.getNameFullnameFromFieldKey_CBC(dat.field_name).nick_name
                    dat['parameter'] = this.getNameFullnameFromFieldKey_CBC(dat.field_name).full_name
                })

                this.dataCBCSpecLN.outlab.forEach(dat=>{
                    dat['abb'] = this.getNameFullnameFromFieldKey_CBC(dat.field_name).nick_name
                    dat['parameter'] = this.getNameFullnameFromFieldKey_CBC(dat.field_name).full_name
                })


              
                 this.dataCBCSpecLN.info.tentative_dx_stbe =  this.dataCBCSpecLN.info.tentative_dx ? Buffer.from(this.dataCBCSpecLN.info.tentative_dx).toString('base64') : this.dataCBCSpecLN.info.tentative_dx
           

              
                 this.dataCBCSpecLN.info.comment_note_stbe =   this.dataCBCSpecLN.info.comment_note ? Buffer.from(this.dataCBCSpecLN.info.comment_note).toString('base64') : this.dataCBCSpecLN.info.comment_note
            

               
                 this.dataCBCSpecLN.info.diagnosis_note_stbe =  this.dataCBCSpecLN.info.diagnosis_note ? Buffer.from(this.dataCBCSpecLN.info.diagnosis_note).toString('base64') : this.dataCBCSpecLN.info.diagnosis_note
                 

          
                 this.dataCBCSpecLN.info.result_remark_stbe = this.dataCBCSpecLN.info.result_remark ? Buffer.from(this.dataCBCSpecLN.info.result_remark).toString('base64') : this.dataCBCSpecLN.info.result_remark
               

                 this.dataCBCSpecLN.info.print_by =  this.user_full_name_surname


                  
                // if(this.dataCBCSpecLN.info.tentative_dx){
                //  this.dataCBCSpecLN.info.tentative_dx_stbe = this.getDecodeFromBase64ToHtml(this.dataCBCSpecLN.info.tentative_dx)
                // }

                // if(this.dataCBCSpecLN.info.comment_note){
                //  this.dataCBCSpecLN.info.comment_note_stbe = this.getDecodeFromBase64ToHtml(this.dataCBCSpecLN.info.comment_note)
                // }

                // if(this.dataCBCSpecLN.info.diagnosis_note){
                //  this.dataCBCSpecLN.info.diagnosis_note_stbe = this.getDecodeFromBase64ToHtml(this.dataCBCSpecLN.info.diagnosis_note)
                // }

                // if(this.dataCBCSpecLN.info.result_remark){
                //  this.dataCBCSpecLN.info.result_remark_stbe = this.getDecodeFromBase64ToHtml(this.dataCBCSpecLN.info.result_remark)
                // }
       

                const datTo = this.dataCBCSpecLN

                 

                // console.log(JSON.stringify(datTo))


                this.isFullScreenSearching = false 
                axios.defaults.headers.common['Authorization'] = `Bearer ${this.access_token}`
                axios.post(`${getBaseURLforBackEnd()}/api/make_report_result_cbc`,datTo,getConfigAxios())
                        .then((res)=>{
                          // {
                          //   "url": "https://kuvdl.vet.ku.ac.th/static/gen_report_result_cbc/2025-12-11/2WaTNzwXqc7BIwJi9TS59XZgM.pdf"
                          // }
                          if(CALL_FROM == 1){  // 0 == labpatho.vet.ku.ac.th , 1 == local(172.16.2.116) , 2 == https://kuvdl.vet.ku.ac.th
                            const urlObj = new URL(res.data.url);

                            urlObj.protocol = 'http:';
                            // เปลี่ยน Hostname (IP)
                            urlObj.hostname = '172.16.2.117';
                            // ลบ Port อื่นๆออก (ถ้าต้องการให้เป็น default port 80)
                            urlObj.port = '';
                            const finalUrl = urlObj.toString();
                            console.log(finalUrl);
                            window.open(`${finalUrl}`, '_blank')
                          }else{
                            window.open(`${res.data.url}`, '_blank')
                          }


                            // window.open(`${res.data.url}`, '_blank', 'location=no,height=570,width=520,scrollbars=yes,status=yes')
                            // window.open(`${res.data.url}`, '_blank', )
                            this.isFullScreenSearching = false
                        })
                        .catch((err)=>{
                                this.$buefy.toast.open({
                                duration: 1000,
                                message: `${err.data}`,
                                position: 'is-bottom',
                                type: 'is-danger'
                            })
                            this.isFullScreenSearching = false
                        })


        // console.log(JSON.stringify(this.dataCBCSpecLN))




        },
        imageModal(dataUrl){
              
                if(dataUrl !== "") {
                    this.dataUrl = this.getURLImgWithUUID( dataUrl )
                }else{
                    this.dataUrl = 'imgnotaval.jpg'
                }
                this.isImageModalActive = true
                
        },
        getURLImgWithUUID(path){
              return `${getBaseURLLabCBCImages()}${this.IDLABSelected.idlab}/${path}?${genUUID(12)}`
        },
        onlyBugUAInPrevVersion(ua_v1){
              if (ua_v1.length == 3) {
                    const checkForIds = ["ur_sp_gr", "ur_ph", "ur_creatinine"];
                    let checkSum = 0 
                    for (let i = 0; i <= ua_v1.length-1; i++) {
                        const item = ua_v1[i];
                        if (checkForIds.includes(item.id)  && item.val == 0) {
                           checkSum++         
                       
                        }
                    }
                  return  checkSum==3
                 } 
            return false;
        },
        closeManuallyCreateLabAutomateShow(){
            this.isManuallyCreateLabAutomateShowing = false

            if(this.hasEditImagesHappenWhenEdit){
                this.setHasEditImagesHappenWhenEdit(false) 
                this.$emit('trigRequestRefreshDataCBC')
            }

        },
        closeManuallyCreateLabAutomate_WithChangeData(){
            this.$emit('trigRequestRefreshDataCBC')
            this.isManuallyCreateLabAutomateShowing = false
        },

        changeStatusCBCLab(){
           this.isFullScreenSearching = true
           const datTo = {
                  "idlab": this.dataCBCSpecLN.info.idlab,
                  "enable_status" : !this.dataCBCSpecLN.info.status
           }
           axios.defaults.headers.common['Authorization'] = `Bearer ${this.access_token})}`
           axios.post(`${getBaseURLforBackEnd()}/api/enable_disable_labautomate_by_manual`, datTo , getConfigAxios())
                .then((res)=>{
                     this.dataCBCSpecLN.info.status = !this.dataCBCSpecLN.info.status
                     // find in 
                     const tmp1 = this.listoflabopdtarget_v2.find(dat=>dat.idlab == res.data.idlab)
                     if(tmp1){
                        tmp1.status_cbc_lab = res.data.status
                     }
                    //  find in
                    const tmp2 = this.CBCWorkList.find(dat=>dat.idlab == res.data.idlab)
                     if(tmp2){
                        tmp2.status_lab_cbc = res.data.status
                     } 
                     this.isFullScreenSearching = false
                })
                .catch((err)=>{
                                    this.$buefy.toast.open({
                                    duration: 1000,
                                    message: `${err.data}`,
                                    position: 'is-bottom',
                                    type: 'is-success'
                                })
                                this.isFullScreenLoading = false
                            })
                 

      },

      async  ManuallyCreateLabAutomateShow(){
            
            this.setModeManuallyLabAutomate(1)
            

            // const isDiagnosisNoteEmpty = !!(this.dataCBCSpecLN?.info?.diagnosis_note ?? '')
            // const isResult_RemarkEmpty = !!(this.dataCBCSpecLN?.info?.result_remark ?? '')   
            // const isTentative_dxEmpty = !!(this.dataCBCSpecLN?.info?.tentative_dx ?? '')
            // const isComment_noteEmpty = !!(this.dataCBCSpecLN?.info?.comment_note ?? '')   

        
        
        
            // if (isDiagnosisNoteEmpty) {
            //   this.dataCBCSpecLN.info.diagnosis_note = this.getDecodeFromBase64ToHtml(this.dataCBCSpecLN.info.diagnosis_note )
            // }
            // if (isResult_RemarkEmpty) {
            //   this.dataCBCSpecLN.info.result_remark = this.getDecodeFromBase64ToHtml(this.dataCBCSpecLN.info.result_remark )
            // }
            // if (isTentative_dxEmpty) {
            //   this.dataCBCSpecLN.info.tentative_dx = this.getDecodeFromBase64ToHtml(this.dataCBCSpecLN.info.tentative_dx )
            // }
            // if (isComment_noteEmpty) {
            //   this.dataCBCSpecLN.info.comment_note = this.getDecodeFromBase64ToHtml(this.dataCBCSpecLN.info.comment_note )
            // }



            // console.log(JSON.stringify(this.dataCBCSpecLN))
            this.setDataToEdit_ManuallyLabAutomate( Object.assign( {} , this.dataCBCSpecLN ))
            this.isManuallyCreateLabAutomateShowing = true






            // this.isFullScreenSearching = true
           




            // // check  data ready before next
            // if(this.blMor.length==0){
            //   await  this.fetchBlMor()
            // }









            // // set mode to edit mode 
            // this.setModeManuallyLabAutomate(1)



            // // fill data into state
            // for(let i =0;i<= this.dataCBCSpecLN['hm'].length-1;i++){
            //    const tmp = this.lab_HIS_LIS_Mapping['hm'].find(dat=>dat.field_name == this.dataCBCSpecLN['hm'][i].field_name )
            //    if(tmp){
            //     tmp.val = this.dataCBCSpecLN['hm'][i].val
            //     tmp.unit = this.dataCBCSpecLN['hm'][i].unit
            //     tmp.ref = this.dataCBCSpecLN['hm'][i].ref
            //     tmp.flag = this.dataCBCSpecLN['hm'][i].flag
            //     tmp.machine_id = this.dataCBCSpecLN['hm'][i].machine_id
            //    }
            // }
             

            // for(let i =0;i<= this.dataCBCSpecLN['chemistry'].length-1;i++){
            //    const tmp = this.lab_HIS_LIS_Mapping['chemistry'].find(dat=>dat.field_name == this.dataCBCSpecLN['chemistry'][i].field_name )
            //    if(tmp){
            //     tmp.val = this.dataCBCSpecLN['chemistry'][i].val
            //     tmp.ref = this.dataCBCSpecLN['chemistry'][i].ref
            //     tmp.flag = this.dataCBCSpecLN['chemistry'][i].flag
            //     tmp.machine_id = this.dataCBCSpecLN['chemistry'][i].machine_id
            //    }
            // }

            // for(let i =0;i<= this.dataCBCSpecLN['hormone'].length-1;i++){
            //    const tmp = this.lab_HIS_LIS_Mapping['hormone'].find(dat=>dat.field_name == this.dataCBCSpecLN['hormone'][i].field_name )
            //    if(tmp){
            //     tmp.val = this.dataCBCSpecLN['hormone'][i].val
            //     tmp.ref = this.dataCBCSpecLN['hormone'][i].ref
            //     tmp.flag = this.dataCBCSpecLN['hormone'][i].flag
            //     tmp.machine_id = this.dataCBCSpecLN['hormone'][i].machine_id
            //    }
            // }


            // for(let i =0;i<= this.dataCBCSpecLN['blood_gas'].length-1;i++){
            //    const tmp = this.lab_HIS_LIS_Mapping['blood_gas'].find(dat=>dat.field_name == this.dataCBCSpecLN['blood_gas'][i].field_name )
            //    if(tmp){
            //     tmp.val = this.dataCBCSpecLN['blood_gas'][i].val
            //     tmp.ref = this.dataCBCSpecLN['blood_gas'][i].ref
            //     tmp.flag = this.dataCBCSpecLN['blood_gas'][i].flag
            //     tmp.machine_id = this.dataCBCSpecLN['blood_gas'][i].machine_id
            //    }
            // }


            // for(let i =0;i<= this.dataCBCSpecLN['outlab'].length-1;i++){
            //    const tmp = this.lab_HIS_LIS_Mapping['outlab'].find(dat=>dat.field_name == this.dataCBCSpecLN['outlab'][i].field_name )
            //    if(tmp){
            //     tmp.val = this.dataCBCSpecLN['outlab'][i].val
            //     tmp.ref = this.dataCBCSpecLN['outlab'][i].ref
            //     tmp.flag = this.dataCBCSpecLN['outlab'][i].flag
            //     tmp.machine_id = this.dataCBCSpecLN['outlab'][i].machine_id  
            //    }
            // }
 
            // // console.log(this.dataCBCSpecLN['info'].comment_note)

            // if(this.dataCBCSpecLN['info'].comment_note != null || this.dataCBCSpecLN['info'].comment_note != ""  ){
            //     this.setCommentNote(this.dataCBCSpecLN['info'].comment_note) 
            // }
            // if(this.dataCBCSpecLN['info'].singni_phy != null  ){
            //     this.setSingni_phy(this.dataCBCSpecLN['info'].singni_phy) 
            // }
            // if(this.dataCBCSpecLN['info'].tentative_dx != null  ){
            //     this.setTentative_dx(this.dataCBCSpecLN['info'].tentative_dx) 
            // }
            // if(this.dataCBCSpecLN['info'].test_desire != null  ){
            //     this.setTest_desire(this.dataCBCSpecLN['info'].test_desire) 
            // }
            // if(this.dataCBCSpecLN['info'].special_rq != null  ){
            //     this.setSpecial_rq(this.dataCBCSpecLN['info'].special_rq) 
            // }
           

            // //    blood mor
            //  this.blMorSelected.length = 0
            //  for(let i =0;i<=  this.dataCBCSpecLN['blmor'].length-1;i++){
            //    const tmp = this.blMor.find(dat=>dat.id ==  this.dataCBCSpecLN['blmor'][i].idblood_mor_name )
            //    if(tmp){
            //      this.blMorSelected.push(tmp)
            //    }
            // }
           
            
        

            // this.setOpdSelected(
            //                     {
            //                         "address": this.dataCBCSpecLN['info'].address  ,
            //                         "age": this.dataCBCSpecLN['info'].age ,
            //                         "birth": this.dataCBCSpecLN['info'].birth  ,
            //                         "breed":  this.dataCBCSpecLN['info'].breed,
            //                         "date_rec": this.dataCBCSpecLN['info'].date_rec ,
            //                         "idopd":  this.dataCBCSpecLN['info'].idopd ,
            //                         "idown": this.dataCBCSpecLN['info'].idown ,
            //                         "name": this.dataCBCSpecLN['info'].name,
            //                         "owner_name":  this.dataCBCSpecLN['info'].owner_name,
            //                         "phone_mobile": this.dataCBCSpecLN['info'].phone_mobile,
            //                         "sex":  this.dataCBCSpecLN['info'].sex,
            //                         "species": this.dataCBCSpecLN['info'].species ,
            //                         "species_id":  this.dataCBCSpecLN['info'].species_id ,
            //                         "visit_active": this.dataCBCSpecLN['info'].visit_active 
            //                     } 
            // )

            // this.$buefy.toast.open('fill data into state completed')
            

            // // wake up 
            // this.isManuallyCreateLabAutomateShowing = true

            // this.isFullScreenSearching = false
        },
        getClassDependFlag(_flag){
            return  _flag=='H' ? '' : ''
           // return _flag=='H' ? 'has-text-danger has-text-weight-semibold' : ''
        },
        // getNameFullnameFromFieldKey_CBC(_key){
        //   const tmp = this.mapField_Fullname.find(dat=>dat.field_name == _key)
        //   return tmp ? {
        //                         "nick_name" : tmp.nick_name,
        //                         "full_name" : tmp.full_name
        //                 } 
        //              : 
        //                 {
        //                         "nick_name" : "",
        //                         "full_name" : ""
        //                 }
        // }
    },
    data(){
        return{

         



            col1_Width : '15%',   // Param1
            col2_Width : '22%',   // Param2
            col3_Width : '5%',    // Value  
            col4_Width : '10%',   // Unit   
            col5_Width : '10%',   // Ref
            col6_Width : '5%',    // Flag
            col7_Width : '33%',   // machine id

            isManuallyCreateLabAutomateShowing : false,  
            isFullScreenSearching : false,      

            isImageModalActive : false, 
            dataUrl : "",
            
            // data_master :  {
            //                     "hm": [
            //                         {
            //                             "code_lis": "HM001",
            //                             "name_lis": "",
            //                             "field_name": "hm_wbc",
            //                             "val": null,
            //                             "unit": "x 10^3/ul",
            //                             "ref": "5-10",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "HM009",
            //                             "name_lis": "",
            //                             "field_name": "hm_segs",
            //                             "val": null,
            //                             "unit": "%",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "HM012",
            //                             "name_lis": "",
            //                             "field_name": "hm_lymph",
            //                             "val": null,
            //                             "unit": "%",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "HM013",
            //                             "name_lis": "",
            //                             "field_name": "hm_mono",
            //                             "val": null,
            //                             "unit": "%",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "HM010",
            //                             "name_lis": "",
            //                             "field_name": "hm_eos",
            //                             "val": null,
            //                             "unit": "%",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "HM011",
            //                             "name_lis": "",
            //                             "field_name": "hm_baso",
            //                             "val": null,
            //                             "unit": "%",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "HM027",
            //                             "name_lis": "",
            //                             "field_name": "hm_neut",
            //                             "val": null,
            //                             "unit": "x 10^3/ul",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "HM030",
            //                             "name_lis": "",
            //                             "field_name": "hm_lymph1",
            //                             "val": null,
            //                             "unit": "x 10^3/ul",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "HM008",
            //                             "name_lis": "",
            //                             "field_name": "hm_mono1",
            //                             "val": null,
            //                             "unit": "x 10^3/ul",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "HM031",
            //                             "name_lis": "",
            //                             "field_name": "hm_eo",
            //                             "val": null,
            //                             "unit": "x 10^3/ul",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "HM033",
            //                             "name_lis": "",
            //                             "field_name": "hm_baso1",
            //                             "val": null,
            //                             "unit": "x 10^3/ul",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "HM016",
            //                             "name_lis": "",
            //                             "field_name": "hm_nucl_rbc",
            //                             "val": null,
            //                             "unit": "%",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "",
            //                             "name_lis": "",
            //                             "field_name": "hm_nrbc",
            //                             "val": null,
            //                             "unit": "x 10^3/ul",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "HM035",
            //                             "name_lis": "",
            //                             "field_name": "hm_my_cyte",
            //                             "val": null,
            //                             "unit": "%",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "HM036",
            //                             "name_lis": "",
            //                             "field_name": "hm_meta",
            //                             "val": null,
            //                             "unit": "%",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "",
            //                             "name_lis": "",
            //                             "field_name": "hm_blascell",
            //                             "val": null,
            //                             "unit": "%",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "",
            //                             "name_lis": "",
            //                             "field_name": "hm_mastcell",
            //                             "val": null,
            //                             "unit": "%",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "HM014",
            //                             "name_lis": "",
            //                             "field_name": "hm_band",
            //                             "val": null,
            //                             "unit": "%",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "HM005",
            //                             "name_lis": "",
            //                             "field_name": "hm_unclass",
            //                             "val": null,
            //                             "unit": "",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "HM002",
            //                             "name_lis": "",
            //                             "field_name": "hm_rbc",
            //                             "val": null,
            //                             "unit": "x 10^6/ul",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "HM003",
            //                             "name_lis": "",
            //                             "field_name": "hm_hgb",
            //                             "val": null,
            //                             "unit": "g/dL",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "HM048",
            //                             "name_lis": "",
            //                             "field_name": "hm_pcv",
            //                             "val": null,
            //                             "unit": "%",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "",
            //                             "name_lis": "",
            //                             "field_name": "hm_pcv1",
            //                             "val": null,
            //                             "unit": "%",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "HM004",
            //                             "name_lis": "",
            //                             "field_name": "hm_mcv",
            //                             "val": null,
            //                             "unit": "fL",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "",
            //                             "name_lis": "",
            //                             "field_name": "hm_mch",
            //                             "val": null,
            //                             "unit": "pg",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "HM006",
            //                             "name_lis": "",
            //                             "field_name": "hm_mchc",
            //                             "val": null,
            //                             "unit": "g/dL",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "HM054",
            //                             "name_lis": "",
            //                             "field_name": "hm_rdw",
            //                             "val": null,
            //                             "unit": "fL",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "",
            //                             "name_lis": "",
            //                             "field_name": "hm_rdwcv",
            //                             "val": null,
            //                             "unit": "%",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "",
            //                             "name_lis": "",
            //                             "field_name": "hm_plti",
            //                             "val": null,
            //                             "unit": "x 10^3/ul",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "",
            //                             "name_lis": "",
            //                             "field_name": "hm_plto",
            //                             "val": null,
            //                             "unit": "x 10^3/ul",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "HM007",
            //                             "name_lis": "",
            //                             "field_name": "hm_platelets",
            //                             "val": null,
            //                             "unit": "x 10^3/ul",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "HM097",
            //                             "name_lis": "",
            //                             "field_name": "hm_mpv",
            //                             "val": null,
            //                             "unit": "fL",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "",
            //                             "name_lis": "",
            //                             "field_name": "hm_pdw",
            //                             "val": null,
            //                             "unit": "fL",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "",
            //                             "name_lis": "",
            //                             "field_name": "hm_plcr",
            //                             "val": null,
            //                             "unit": "%",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "",
            //                             "name_lis": "",
            //                             "field_name": "hm_pct",
            //                             "val": null,
            //                             "unit": "%",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "CA007",
            //                             "name_lis": "",
            //                             "field_name": "hm_retics",
            //                             "val": null,
            //                             "unit": "%",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "",
            //                             "name_lis": "",
            //                             "field_name": "hm_ret1",
            //                             "val": null,
            //                             "unit": "x 10^6/ul",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "",
            //                             "name_lis": "",
            //                             "field_name": "hm_irf",
            //                             "val": null,
            //                             "unit": "%",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "",
            //                             "name_lis": "",
            //                             "field_name": "hm_lfr",
            //                             "val": null,
            //                             "unit": "%",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "",
            //                             "name_lis": "",
            //                             "field_name": "hm_mfr",
            //                             "val": null,
            //                             "unit": "%",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "",
            //                             "name_lis": "",
            //                             "field_name": "hm_hfr",
            //                             "val": null,
            //                             "unit": "%",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "",
            //                             "name_lis": "",
            //                             "field_name": "hm_ret_he",
            //                             "val": null,
            //                             "unit": "pg",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "",
            //                             "name_lis": "",
            //                             "field_name": "hm_rpi",
            //                             "val": null,
            //                             "unit": "",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "HM015",
            //                             "name_lis": "",
            //                             "field_name": "hm_protein_refract",
            //                             "val": null,
            //                             "unit": "g/100ml",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         }
            //                     ],
            //                     "bf": [
            //                         {
            //                             "code_lis": "",
            //                             "name_lis": "",
            //                             "field_name": "bf_wbcbf",
            //                             "val": null,
            //                             "unit": "x 10^3/ul",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "",
            //                             "name_lis": "",
            //                             "field_name": "bf_rbcbf",
            //                             "val": null,
            //                             "unit": "x 10^6/ul",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "",
            //                             "name_lis": "",
            //                             "field_name": "bf_mn",
            //                             "val": null,
            //                             "unit": "x 10^3/ul",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "",
            //                             "name_lis": "",
            //                             "field_name": "bf_pmn",
            //                             "val": null,
            //                             "unit": "x 10^3/ul",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "",
            //                             "name_lis": "",
            //                             "field_name": "bf_mn1",
            //                             "val": null,
            //                             "unit": "%",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "",
            //                             "name_lis": "",
            //                             "field_name": "bf_pmn1",
            //                             "val": null,
            //                             "unit": "%",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "",
            //                             "name_lis": "",
            //                             "field_name": "bf_tcbf",
            //                             "val": null,
            //                             "unit": "x 10^3/ul",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         }
            //                     ],
            //                     "chemistry": [
            //                         {
            //                             "code_lis": "CM002",
            //                             "name_lis": "",
            //                             "field_name": "bc_bun",
            //                             "val": null,
            //                             "unit": "mg/dL",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "CM003",
            //                             "name_lis": "",
            //                             "field_name": "bc_creatinine",
            //                             "val": null,
            //                             "unit": "mg/dL",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "CM004",
            //                             "name_lis": "",
            //                             "field_name": "bc_uric",
            //                             "val": null,
            //                             "unit": "mg/dL",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "CM005",
            //                             "name_lis": "",
            //                             "field_name": "bc_cholesterol",
            //                             "val": null,
            //                             "unit": "mg/dL",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "CM006",
            //                             "name_lis": "",
            //                             "field_name": "bc_triglyceride",
            //                             "val": null,
            //                             "unit": "mg/dL",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "CM106",
            //                             "name_lis": "",
            //                             "field_name": "bc_protein_biuret",
            //                             "val": null,
            //                             "unit": "g/dL",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "CM107",
            //                             "name_lis": "",
            //                             "field_name": "bc_albumin",
            //                             "val": null,
            //                             "unit": "g/dL",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "CM108",
            //                             "name_lis": "",
            //                             "field_name": "bc_glob",
            //                             "val": null,
            //                             "unit": "g/dL",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "CM010",
            //                             "name_lis": "",
            //                             "field_name": "bc_bilirubin_total",
            //                             "val": null,
            //                             "unit": "mg/dL",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "CM011",
            //                             "name_lis": "",
            //                             "field_name": "bc_direct",
            //                             "val": null,
            //                             "unit": "mg/dL",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "",
            //                             "name_lis": "",
            //                             "field_name": "bc_ast_sgot",
            //                             "val": null,
            //                             "unit": "U/L",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "CM112",
            //                             "name_lis": "",
            //                             "field_name": "bc_alt_sgpt",
            //                             "val": null,
            //                             "unit": "U/L",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "CM009",
            //                             "name_lis": "",
            //                             "field_name": "bc_alk_phos",
            //                             "val": null,
            //                             "unit": "U/L",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "CM026",
            //                             "name_lis": "",
            //                             "field_name": "bc_csf",
            //                             "val": null,
            //                             "unit": "mg/dL",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "SP018",
            //                             "name_lis": "",
            //                             "field_name": "bc_ggt",
            //                             "val": null,
            //                             "unit": "U/L",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "CM028",
            //                             "name_lis": "",
            //                             "field_name": "bc_calcium",
            //                             "val": null,
            //                             "unit": "mg/dL",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "CM029",
            //                             "name_lis": "",
            //                             "field_name": "bc_phosphorus",
            //                             "val": null,
            //                             "unit": "mg/dL",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "CM019",
            //                             "name_lis": "",
            //                             "field_name": "bc_sodium",
            //                             "val": null,
            //                             "unit": "mmol/L",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "CM020",
            //                             "name_lis": "",
            //                             "field_name": "bc_potassium",
            //                             "val": null,
            //                             "unit": "mmol/L",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "CM021",
            //                             "name_lis": "",
            //                             "field_name": "bc_chloride",
            //                             "val": null,
            //                             "unit": "mmol/L",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "CM018",
            //                             "name_lis": "",
            //                             "field_name": "bc_cpk",
            //                             "val": null,
            //                             "unit": "U/L",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "SP021",
            //                             "name_lis": "",
            //                             "field_name": "bc_ammonia",
            //                             "val": null,
            //                             "unit": "umol/L",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "CM001",
            //                             "name_lis": "",
            //                             "field_name": "bc_glucose",
            //                             "val": null,
            //                             "unit": "mg/dL",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "CM041",
            //                             "name_lis": "",
            //                             "field_name": "ur_creatinine",
            //                             "val": null,
            //                             "unit": "mg/dL",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "CM014",
            //                             "name_lis": "",
            //                             "field_name": "bc_upro",
            //                             "val": null,
            //                             "unit": "mg/dL",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "CM031",
            //                             "name_lis": "",
            //                             "field_name": "bc_amylase",
            //                             "val": null,
            //                             "unit": "U/L",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "",
            //                             "name_lis": "",
            //                             "field_name": "bc_crp",
            //                             "val": null,
            //                             "unit": "mg/dL",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "",
            //                             "name_lis": "",
            //                             "field_name": "bc_sdma",
            //                             "val": null,
            //                             "unit": "ug/dL",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "",
            //                             "name_lis": "",
            //                             "field_name": "bc_tt4",
            //                             "val": null,
            //                             "unit": "ug/dL",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "IM015",
            //                             "name_lis": "",
            //                             "field_name": "sp_fructo",
            //                             "val": null,
            //                             "unit": "umol/L",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "",
            //                             "name_lis": "",
            //                             "field_name": "bc_fru",
            //                             "val": null,
            //                             "unit": "mmol/L",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "",
            //                             "name_lis": "",
            //                             "field_name": "bc_lac",
            //                             "val": null,
            //                             "unit": "U/L",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "CM080",
            //                             "name_lis": "",
            //                             "field_name": "sp_lipase",
            //                             "val": null,
            //                             "unit": "U/L",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "CM030",
            //                             "name_lis": "",
            //                             "field_name": "bc_mg",
            //                             "val": null,
            //                             "unit": "mg/dL",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "",
            //                             "name_lis": "",
            //                             "field_name": "bc_prog",
            //                             "val": null,
            //                             "unit": "ng/mL",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "",
            //                             "name_lis": "",
            //                             "field_name": "bc_bileacid_fasting",
            //                             "val": null,
            //                             "unit": "umol/L",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         }
            //                     ],
            //                     "hormone": [
            //                         {
            //                             "code_lis": "CM138",
            //                             "name_lis": "",
            //                             "field_name": "hom_t4",
            //                             "val": null,
            //                             "unit": "ug/dL",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "",
            //                             "name_lis": "",
            //                             "field_name": "hom_ctsh",
            //                             "val": null,
            //                             "unit": "ng/mL",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "",
            //                             "name_lis": "",
            //                             "field_name": "hom_ctli",
            //                             "val": null,
            //                             "unit": "ng/mL",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "TX019",
            //                             "name_lis": "",
            //                             "field_name": "sp_phenobarb",
            //                             "val": null,
            //                             "unit": "ug/dL",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "CM0491",
            //                             "name_lis": "",
            //                             "field_name": "hor_acth",
            //                             "val": null,
            //                             "unit": "pg/mL",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "CM024",
            //                             "name_lis": "Free T4",
            //                             "field_name": "hor_freet4",
            //                             "val": null,
            //                             "unit": "ng%",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "SP020",
            //                             "name_lis": "",
            //                             "field_name": "hom_cotis",
            //                             "val": null,
            //                             "unit": "ug/dL",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "CM079",
            //                             "name_lis": "",
            //                             "field_name": "hor_insulin",
            //                             "val": null,
            //                             "unit": "uIU/mL",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "CM114",
            //                             "name_lis": "",
            //                             "field_name": "hor_pth",
            //                             "val": null,
            //                             "unit": "pg/mL",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "PT032",
            //                             "name_lis": "",
            //                             "field_name": "hor_pro",
            //                             "val": null,
            //                             "unit": "ng/mL",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "IM007",
            //                             "name_lis": "",
            //                             "field_name": "hor_tes",
            //                             "val": null,
            //                             "unit": "ng/mL",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "",
            //                             "name_lis": "",
            //                             "field_name": "hor_urin_costisol",
            //                             "val": null,
            //                             "unit": "",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "",
            //                             "name_lis": "Estradiol",
            //                             "field_name": "hor_estra",
            //                             "val": null,
            //                             "unit": "pg/mL",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         }
            //                     ],
            //                     "blood_gas": [
            //                         {
            //                             "code_lis": "CM051",
            //                             "name_lis": "",
            //                             "field_name": "bg_ph",
            //                             "val": null,
            //                             "unit": "",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "CM052",
            //                             "name_lis": "",
            //                             "field_name": "bg_pco2",
            //                             "val": null,
            //                             "unit": "mmHg",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "CM053",
            //                             "name_lis": "",
            //                             "field_name": "bg_po2",
            //                             "val": null,
            //                             "unit": "mmHg",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "CM123",
            //                             "name_lis": "",
            //                             "field_name": "bg_na",
            //                             "val": null,
            //                             "unit": "mmol/L",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "CM054",
            //                             "name_lis": "",
            //                             "field_name": "bg_k",
            //                             "val": null,
            //                             "unit": "mmol/L",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "CM062",
            //                             "name_lis": "",
            //                             "field_name": "bg_ci",
            //                             "val": null,
            //                             "unit": "mmol/L",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "CM055",
            //                             "name_lis": "",
            //                             "field_name": "bg_ca",
            //                             "val": null,
            //                             "unit": "mmol/L",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "CM056",
            //                             "name_lis": "",
            //                             "field_name": "bg_hb",
            //                             "val": null,
            //                             "unit": "g/dL",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "CM122",
            //                             "name_lis": "",
            //                             "field_name": "bg_hct",
            //                             "val": null,
            //                             "unit": "%",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "CM120",
            //                             "name_lis": "",
            //                             "field_name": "bg_hco3",
            //                             "val": null,
            //                             "unit": "mmol/L",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "CM200",
            //                             "name_lis": "",
            //                             "field_name": "bg_be",
            //                             "val": null,
            //                             "unit": "mmol/L",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "CM201",
            //                             "name_lis": "",
            //                             "field_name": "bg_ctco2",
            //                             "val": null,
            //                             "unit": "mmol/L",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "CM203",
            //                             "name_lis": "",
            //                             "field_name": "bg_pht",
            //                             "val": null,
            //                             "unit": "",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "CM204",
            //                             "name_lis": "",
            //                             "field_name": "bg_pco2t",
            //                             "val": null,
            //                             "unit": "",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "CM205",
            //                             "name_lis": "",
            //                             "field_name": "bg_po2t",
            //                             "val": null,
            //                             "unit": "mmHg",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "CM202",
            //                             "name_lis": "",
            //                             "field_name": "bg_so2est",
            //                             "val": null,
            //                             "unit": "%",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "CM206",
            //                             "name_lis": "",
            //                             "field_name": "bg_ica",
            //                             "val": null,
            //                             "unit": "mmol/L",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "",
            //                             "name_lis": "",
            //                             "field_name": "bg_glc",
            //                             "val": null,
            //                             "unit": "mg/dL",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "",
            //                             "name_lis": "",
            //                             "field_name": "bg_lac",
            //                             "val": null,
            //                             "unit": "mmol/L",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "",
            //                             "name_lis": "",
            //                             "field_name": "bg_temp",
            //                             "val": null,
            //                             "unit": "F",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "",
            //                             "name_lis": "",
            //                             "field_name": "bg_fio2",
            //                             "val": null,
            //                             "unit": "%",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "",
            //                             "name_lis": "",
            //                             "field_name": "bg_bp",
            //                             "val": null,
            //                             "unit": "mmHg",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "CM207",
            //                             "name_lis": "",
            //                             "field_name": "bg_hco3std",
            //                             "val": null,
            //                             "unit": "mmol/L",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "CM208",
            //                             "name_lis": "",
            //                             "field_name": "bg_beecf",
            //                             "val": null,
            //                             "unit": "mmol/L",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "",
            //                             "name_lis": "",
            //                             "field_name": "bg_cna",
            //                             "val": null,
            //                             "unit": "mmol/L",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "",
            //                             "name_lis": "",
            //                             "field_name": "bg_ck",
            //                             "val": null,
            //                             "unit": "mmol/L",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "",
            //                             "name_lis": "",
            //                             "field_name": "bg_cca2",
            //                             "val": null,
            //                             "unit": "mmol/L",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "",
            //                             "name_lis": "",
            //                             "field_name": "bg_cci",
            //                             "val": null,
            //                             "unit": "mmol/L",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "",
            //                             "name_lis": "",
            //                             "field_name": "bg_cglc",
            //                             "val": null,
            //                             "unit": "mg/dL",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "",
            //                             "name_lis": "",
            //                             "field_name": "bg_clac",
            //                             "val": null,
            //                             "unit": "mmol/L",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "",
            //                             "name_lis": "",
            //                             "field_name": "bg_ctbil",
            //                             "val": null,
            //                             "unit": "mmol/L",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "",
            //                             "name_lis": "",
            //                             "field_name": "bg_cthb",
            //                             "val": null,
            //                             "unit": "mg/dL",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "",
            //                             "name_lis": "",
            //                             "field_name": "bg_fhhb",
            //                             "val": null,
            //                             "unit": "%",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "",
            //                             "name_lis": "",
            //                             "field_name": "bg_fo2hb",
            //                             "val": null,
            //                             "unit": "%",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "",
            //                             "name_lis": "",
            //                             "field_name": "bg_fcohb",
            //                             "val": null,
            //                             "unit": "%",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "",
            //                             "name_lis": "",
            //                             "field_name": "bg_fmethb",
            //                             "val": null,
            //                             "unit": "%",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "",
            //                             "name_lis": "",
            //                             "field_name": "bg_so2",
            //                             "val": null,
            //                             "unit": "%",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "",
            //                             "name_lis": "",
            //                             "field_name": "bg_ag",
            //                             "val": null,
            //                             "unit": "mmol/L",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "",
            //                             "name_lis": "",
            //                             "field_name": "bg_agk",
            //                             "val": null,
            //                             "unit": "mmol/L",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "",
            //                             "name_lis": "",
            //                             "field_name": "bg_chact",
            //                             "val": null,
            //                             "unit": "mmol/L",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "",
            //                             "name_lis": "",
            //                             "field_name": "bg_chstd",
            //                             "val": null,
            //                             "unit": "mmol/L",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "",
            //                             "name_lis": "",
            //                             "field_name": "bg_cbeecf",
            //                             "val": null,
            //                             "unit": "mmol/L",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "",
            //                             "name_lis": "",
            //                             "field_name": "bg_cbeb",
            //                             "val": null,
            //                             "unit": "mmol/L",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "",
            //                             "name_lis": "",
            //                             "field_name": "bg_cbb",
            //                             "val": null,
            //                             "unit": "mmol/L",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "",
            //                             "name_lis": "",
            //                             "field_name": "bg_ctco2b",
            //                             "val": null,
            //                             "unit": "torr",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "",
            //                             "name_lis": "",
            //                             "field_name": "bg_hct",
            //                             "val": null,
            //                             "unit": "%",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "",
            //                             "name_lis": "",
            //                             "field_name": "bg_bo2",
            //                             "val": null,
            //                             "unit": "torr",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "",
            //                             "name_lis": "",
            //                             "field_name": "bg_p50",
            //                             "val": null,
            //                             "unit": "torr",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "",
            //                             "name_lis": "",
            //                             "field_name": "bg_p50t",
            //                             "val": null,
            //                             "unit": "torr",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "",
            //                             "name_lis": "",
            //                             "field_name": "bg_p50st",
            //                             "val": null,
            //                             "unit": "torr",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "",
            //                             "name_lis": "",
            //                             "field_name": "bg_po2fio2",
            //                             "val": null,
            //                             "unit": "torr",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "",
            //                             "name_lis": "",
            //                             "field_name": "bg_cca2p",
            //                             "val": null,
            //                             "unit": "mmol/L",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "",
            //                             "name_lis": "",
            //                             "field_name": "bg_po2a",
            //                             "val": null,
            //                             "unit": "torr",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "",
            //                             "name_lis": "",
            //                             "field_name": "bg_po2at",
            //                             "val": null,
            //                             "unit": "torr",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "",
            //                             "name_lis": "",
            //                             "field_name": "bg_po2aa",
            //                             "val": null,
            //                             "unit": "torr",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "",
            //                             "name_lis": "",
            //                             "field_name": "bg_po2aat",
            //                             "val": null,
            //                             "unit": "torr",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "",
            //                             "name_lis": "",
            //                             "field_name": "bg_po2aa1",
            //                             "val": null,
            //                             "unit": "torr",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "",
            //                             "name_lis": "",
            //                             "field_name": "bg_po2aat1",
            //                             "val": null,
            //                             "unit": "torr",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "",
            //                             "name_lis": "",
            //                             "field_name": "bg_ri",
            //                             "val": null,
            //                             "unit": "",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "",
            //                             "name_lis": "",
            //                             "field_name": "bg_rit",
            //                             "val": null,
            //                             "unit": "",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "",
            //                             "name_lis": "",
            //                             "field_name": "bg_cto2a",
            //                             "val": null,
            //                             "unit": "Vol%",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "",
            //                             "name_lis": "",
            //                             "field_name": "bg_cto2b",
            //                             "val": null,
            //                             "unit": "Vol%",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "",
            //                             "name_lis": "",
            //                             "field_name": "bg_cto2v",
            //                             "val": null,
            //                             "unit": "Vol%",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "",
            //                             "name_lis": "",
            //                             "field_name": "bg_cto2av",
            //                             "val": null,
            //                             "unit": "Vol%",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "",
            //                             "name_lis": "",
            //                             "field_name": "bg_cto2ava",
            //                             "val": null,
            //                             "unit": "Vol%",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "",
            //                             "name_lis": "",
            //                             "field_name": "bg_h",
            //                             "val": null,
            //                             "unit": "cm",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "",
            //                             "name_lis": "",
            //                             "field_name": "bg_w",
            //                             "val": null,
            //                             "unit": "kg",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "",
            //                             "name_lis": "",
            //                             "field_name": "bg_ptmp",
            //                             "val": null,
            //                             "unit": "F",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         }
            //                     ],
            //                     "outlab": [
            //                         {
            //                             "code_lis": "CM128",
            //                             "name_lis": "17-Hydroxy Progesterone",
            //                             "field_name": "ol_17",
            //                             "val": null,
            //                             "unit": "ng/mL",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "IM018",
            //                             "name_lis": "Adrenocorticotrophic Hormone",
            //                             "field_name": "ol_afp",
            //                             "val": null,
            //                             "unit": "",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "",
            //                             "name_lis": "Alpha1 antitrypsin",
            //                             "field_name": "ol_aph1",
            //                             "val": null,
            //                             "unit": "mg/dL",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "HM043",
            //                             "name_lis": "Anti Thrombin III",
            //                             "field_name": "ol_antit",
            //                             "val": null,
            //                             "unit": "%",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "",
            //                             "name_lis": "Bromide",
            //                             "field_name": "ol_bm",
            //                             "val": null,
            //                             "unit": "mg/dL",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "SP035",
            //                             "name_lis": "C-Peptide",
            //                             "field_name": "ol_cp",
            //                             "val": null,
            //                             "unit": "ng/mL",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "",
            //                             "name_lis": "Calcitonin",
            //                             "field_name": "ol_cctn",
            //                             "val": null,
            //                             "unit": "pg/mL",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "",
            //                             "name_lis": "D-Dimer",
            //                             "field_name": "ol_ddim",
            //                             "val": null,
            //                             "unit": "ng/mL",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "SP1002",
            //                             "name_lis": "Erytropoietin level",
            //                             "field_name": "ol_epo",
            //                             "val": null,
            //                             "unit": "mIU/mL",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "SP043",
            //                             "name_lis": "Ferritin",
            //                             "field_name": "ol_ferrt",
            //                             "val": null,
            //                             "unit": "ng/mL",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "IM006",
            //                             "name_lis": "Folate in serum",
            //                             "field_name": "ol_flat",
            //                             "val": null,
            //                             "unit": "ng/ml",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "",
            //                             "name_lis": "Gastrin",
            //                             "field_name": "ol_gast",
            //                             "val": null,
            //                             "unit": "pg/mL",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "",
            //                             "name_lis": "Growth homone",
            //                             "field_name": "ol_gh",
            //                             "val": null,
            //                             "unit": "ng/mL",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "MB147",
            //                             "name_lis": "Hemoculture",
            //                             "field_name": "ol_hmct",
            //                             "val": null,
            //                             "unit": "",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "CM032",
            //                             "name_lis": "Hemoglobin A1C",
            //                             "field_name": "ol_ha1c",
            //                             "val": null,
            //                             "unit": "mmol/mol",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "SP200",
            //                             "name_lis": "IGF1",
            //                             "field_name": "ol_igf1",
            //                             "val": null,
            //                             "unit": "",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "",
            //                             "name_lis": "Magnesium (Urine)",
            //                             "field_name": "ol_magu",
            //                             "val": null,
            //                             "unit": "mg/24 hrs.",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "CA003",
            //                             "name_lis": "Partial Thromboplastin time",
            //                             "field_name": "ol_ptt",
            //                             "val": null,
            //                             "unit": "seconds",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "",
            //                             "name_lis": "Prothrombin Time",
            //                             "field_name": "ol_pt",
            //                             "val": null,
            //                             "unit": "seconds",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "",
            //                             "name_lis": "Rubella Ab. IgG",
            //                             "field_name": "ol_rbl",
            //                             "val": null,
            //                             "unit": "IU/mL",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "",
            //                             "name_lis": "Serum Osmolality",
            //                             "field_name": "ol_sro",
            //                             "val": null,
            //                             "unit": "mOsm/kg",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "",
            //                             "name_lis": "Triiodothyronine",
            //                             "field_name": "ol_t3",
            //                             "val": null,
            //                             "unit": "ng%",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "HT007",
            //                             "name_lis": "Thrombin Time",
            //                             "field_name": "ol_tt",
            //                             "val": null,
            //                             "unit": "seconds",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "CM099",
            //                             "name_lis": "Thyroglobulin Ab.",
            //                             "field_name": "ol_tyab",
            //                             "val": null,
            //                             "unit": "IU/mL",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "SP042",
            //                             "name_lis": "Transferrin",
            //                             "field_name": "ol_tfr1",
            //                             "val": null,
            //                             "unit": "g/L",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "SP044",
            //                             "name_lis": "Transferrin saturation",
            //                             "field_name": "ol_tfr2",
            //                             "val": null,
            //                             "unit": "%",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "CM057",
            //                             "name_lis": "Troponin T",
            //                             "field_name": "ol_tpt",
            //                             "val": null,
            //                             "unit": "ng/mL",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "CM171",
            //                             "name_lis": "Urine Osmolality",
            //                             "field_name": "ol_uro",
            //                             "val": null,
            //                             "unit": "mOsm/kg",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "CM143",
            //                             "name_lis": "Urine VMA",
            //                             "field_name": "ol_uvma",
            //                             "val": null,
            //                             "unit": "mg/day",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         },
            //                         {
            //                             "code_lis": "",
            //                             "name_lis": "Vitamin B12",
            //                             "field_name": "ol_vb12",
            //                             "val": null,
            //                             "unit": "pg/mL",
            //                             "ref": "",
            //                             "flag": "",
            //                             "machine_id": ""
            //                         }
            //                     ]
            //                 },
            

            // data_req :{
            //                 "hm": [
            //                     {
            //                         "field_name": "hm_wbc",
            //                         "val": "12.68",
            //                         "unit": null,
            //                         "ref": null,
            //                         "flag": null,
            //                         "machine_id": null
            //                     },
            //                     {
            //                         "field_name": "hm_segs",
            //                         "val": "56.80",
            //                         "unit": null,
            //                         "ref": null,
            //                         "flag": null,
            //                         "machine_id": null
            //                     },
            //                     {
            //                         "field_name": "hm_lymph",
            //                         "val": "31.60",
            //                         "unit": null,
            //                         "ref": null,
            //                         "flag": null,
            //                         "machine_id": null
            //                     },
            //                     {
            //                         "field_name": "hm_mono",
            //                         "val": "4.70",
            //                         "unit": null,
            //                         "ref": null,
            //                         "flag": null,
            //                         "machine_id": null
            //                     },
            //                     {
            //                         "field_name": "hm_eos",
            //                         "val": "6.70",
            //                         "unit": null,
            //                         "ref": null,
            //                         "flag": null,
            //                         "machine_id": null
            //                     },
            //                     {
            //                         "field_name": "hm_baso",
            //                         "val": "0.20",
            //                         "unit": null,
            //                         "ref": null,
            //                         "flag": null,
            //                         "machine_id": null
            //                     },
            //                     {
            //                         "field_name": "hm_rbc",
            //                         "val": "6.41",
            //                         "unit": null,
            //                         "ref": null,
            //                         "flag": null,
            //                         "machine_id": null
            //                     },
            //                     {
            //                         "field_name": "hm_hgb",
            //                         "val": "14.20",
            //                         "unit": null,
            //                         "ref": null,
            //                         "flag": null,
            //                         "machine_id": null
            //                     },
            //                     {
            //                         "field_name": "hm_pcv",
            //                         "val": "40.90",
            //                         "unit": null,
            //                         "ref": null,
            //                         "flag": null,
            //                         "machine_id": null
            //                     },
            //                     {
            //                         "field_name": "hm_rdw",
            //                         "val": "13.40",
            //                         "unit": null,
            //                         "ref": null,
            //                         "flag": null,
            //                         "machine_id": null
            //                     },
            //                     {
            //                         "field_name": "hm_platelets",
            //                         "val": "70.00",
            //                         "unit": null,
            //                         "ref": null,
            //                         "flag": null,
            //                         "machine_id": null
            //                     },
            //                     {
            //                         "field_name": "hm_mpv",
            //                         "val": "9.40",
            //                         "unit": null,
            //                         "ref": null,
            //                         "flag": null,
            //                         "machine_id": null
            //                     },
            //                     {
            //                         "field_name": "hm_protein_refract",
            //                         "val": "8.00",
            //                         "unit": null,
            //                         "ref": null,
            //                         "flag": null,
            //                         "machine_id": null
            //                     }
            //                 ],
            //                 "bf": [],
            //                 "chemistry": [
            //                     {
            //                         "field_name": "bc_bun",
            //                         "val": "22.00",
            //                         "unit": null,
            //                         "ref": null,
            //                         "flag": null,
            //                         "machine_id": null
            //                     },
            //                     {
            //                         "field_name": "bc_creatinine",
            //                         "val": "0.65",
            //                         "unit": null,
            //                         "ref": null,
            //                         "flag": null,
            //                         "machine_id": null
            //                     },
            //                     {
            //                         "field_name": "bc_albumin",
            //                         "val": "3.00",
            //                         "unit": null,
            //                         "ref": null,
            //                         "flag": null,
            //                         "machine_id": null
            //                     },
            //                     {
            //                         "field_name": "bc_alt_sgpt",
            //                         "val": "101.00",
            //                         "unit": null,
            //                         "ref": null,
            //                         "flag": null,
            //                         "machine_id": null
            //                     },
            //                     {
            //                         "field_name": "bc_alk_phos",
            //                         "val": "83.00",
            //                         "unit": null,
            //                         "ref": null,
            //                         "flag": null,
            //                         "machine_id": null
            //                     }
            //                 ],
            //                 "hormone": [],
            //                 "blood_gas": [],
            //                 "outlab": [],
            //                 "blmor": [],
            //                 "blparasite_v1": [],
            //                 "blparasite_v2": [],
            //                 "ua_v1": [],
            //                 "ua_v2": [],
            //                 "info": {
            //                     "idlab": "66113441",
            //                     "singni_phy": null,
            //                     "tentative_dx": null,
            //                     "test_desire": null,
            //                     "special_rq": null,
            //                     "comment_note": "PLT Clumps",
            //                     "ref_no": "A638660073553",
            //                     "date_req": "2023-05-08",
            //                     "time_req": "10:01:21",
            //                     "req_by": "ภาสินี  สกุลชาติวุฒิ",
            //                     "date_accept": "2023-05-08",
            //                     "time_accept": "10:09:55",
            //                     "accept_by": "ภาวินี  ผลงามเนตรอรุณ",
            //                     "date_cancel": null,
            //                     "time_cancel": null,
            //                     "cancel_by": "",
            //                     "date_reject": null,
            //                     "time_reject": null,
            //                     "reject_by": "",
            //                     "date_resulted": "2023-05-08",
            //                     "time_resulted": "10:50:13",
            //                     "resulted_by": "LIS  SOFTWARE",
            //                     "date_resulted_n": null,
            //                     "time_resulted_n_time": null,
            //                     "resulted_n_by": "",
            //                     "hold": false,
            //                     "ref1": "2338",
            //                     "patho_job": false
            //                 }
            //             }
                                    

        }
    }
}
</script>



<style scoped>


   img{
        cursor: pointer;
        width:100%;
        height:100%;
        object-fit: contain;

    }




</style>    




